import type { IOrganization } from '@/types/organization'

const isDemoOrganization = (organization: IOrganization): boolean => organization.isDemo

export default isDemoOrganization
